import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import RichTextEditor from "react-rte";
import { ButtonMain } from "components";
import { httpRequestsOnSuccessActions, noteActions } from "store";
import { FindLoad, FindSuccessItem, usePrimaryModal } from "utils";
import { Editor } from "./editor";
import { Svg } from "assets";

export const AddNotes = ({ item, onResource, currentId }) => {
  const [inputs, setInputs] = useState({});
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const { closePrimary } = usePrimaryModal();
  const ACTION_TYPE = inputs?.id ? "EDIT_GLOBAL_NOTE" : "CREATE_GLOBAL_NOTE";
  const success = FindSuccessItem(ACTION_TYPE);
  const loading = FindLoad(ACTION_TYPE);

  useEffect(() => {
    if (item) {
      const params = {
        ...item,
      };

      params.note = RichTextEditor.createValueFromString(item?.text, "html");
      setInputs(params);
    }
  }, [item]);

  useEffect(() => {
    if (success?.type === ACTION_TYPE) {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
      closePrimary();
    }
  }, [success]);

  const handleSubmit = () => {
    if (inputs?.note) {
      const editParams = {
        text: inputs?.note?.toString("html"),
        resource: currentId,
        subject: " ",
        onResource,
      };

      if (item?.id) {
        dispatch(
          noteActions.editGlobalNote(item?.id, editParams, {
            id: currentId,
            onResource,
          }),
        );
      } else {
        dispatch(noteActions.createGlobalNote(editParams));
      }
    } else {
      setError(!inputs?.note ? "note" : "");
    }
  };

  const handleCancel = () => {
    setError("");
    setInputs({});
    closePrimary();
  };

  return (
    <div className="note-modal-wrapper">
      <div className="modal-header-main">
        <h3 className="modal-header-title">{item ? "Edit" : "Add New"} Note</h3>

        <button
          className="modal-close-btn-main"
          type="button"
          onClick={closePrimary}
        >
          <Svg.CloseSvg />
        </button>
      </div>

      <div className="modal-body-main">
        <Editor
          inputs={inputs}
          setInputs={setInputs}
          error={error}
          setError={setError}
        />
      </div>

      <div className="modal-footer-main">
        <ButtonMain
          text="Cancel"
          cancel
          buttonMainStyles={{
            width: "fit-content",
          }}
          onClick={handleCancel}
        />
        <ButtonMain
          onClick={handleSubmit}
          text={item ? "Save" : "Add"}
          load={!!loading?.length}
          buttonMainStyles={{
            width: "80px",
          }}
        />
      </div>
    </div>
  );
};
